import { Component } from '@angular/core';
import { ItemType } from '../formulario/request.model';
import { CoreComponent } from '../core/core.component';
import { AsociadosListadoComponent } from './asociados-listado/asociados-listado.component';

/**
 * Listado principal de asociados. Wave 2.1: ya NO descarga los ~19.000 asociados; el listado paginado, con búsqueda y filtro
 * por asociación, lo aporta app-asociados-listado (API paginada). La creación sigue gestionándola app-core.
 */
@Component({
  selector: 'app-asociados',
  standalone: true,
  imports: [CoreComponent, AsociadosListadoComponent],
  templateUrl: './asociados.component.html',
  styleUrl: './asociados.component.scss'
})
export class AsociadosComponent {
  type: ItemType = ItemType.ASOCIADOS;
  titleForm = 'Crear asociado';
}
